module.exports = __webpack_public_path__ + "img/prospectus.d2037653.jpg";